module.exports = __webpack_public_path__ + "static/media/p2a2.7c19b74f.wav";